<div class="grid">
  <ng-container
    *ngIf="currentStep === stepNumber || (currentStep > stepNumber && isLast) || (currentStep < stepNumber && isFirst)"
  >
    <div class="content">
      <ng-content select="[step-content]"></ng-content>
    </div>
  </ng-container>
</div>
